/* Routing */
import { Outlet } from "react-router-dom";

export default function Layout() {

    return (
        <>
            <div className="content-wrapper">
                <Outlet />
            </div>
        </>
    )
}
